// @flow

import React from 'react';
import Configuration from './configuration';
import type { CartPrice } from '../../../../store/configuration/cart/types';

type ACFProps = {|
  field_key: string,
  form: string,
  carConfiguration: Object,
  carPrice: CartPrice,
  dispatch: Function,
|};

export default ({
  field_key,
  form,
  ...rest
}: ACFProps) => (
  <Configuration
    formName={form}
    name={field_key}
    {...rest}
  />
);
